import { useMemo } from 'react';
import styled from 'styled-components';
import { useComite } from '../../../../../../appStore/comite';
import LinkBtn from '../../../../../CompUtils/LinkBtn';
import { MiembroComiteType } from '../../../ConfeccionPrimerActa/GenerarAprobacion/ComiteMiembrosPopup';

type StyleProps = Partial<{ bottomBorder: boolean; idRol: number }>;
const CenterdCol = styled.td<StyleProps>`
  text-align: center;
  vertical-align: middle !important;
  border-bottom: ${({ bottomBorder }) => (bottomBorder ? '2px solid darkgray' : undefined)};
`;

const Row = styled.tr<StyleProps>`
  vertical-align: middle !important;
  & > td:first-child {
    border-bottom: 2px solid darkgray;
  }
  border-bottom: ${({ bottomBorder }) => (bottomBorder ? '2px solid darkgray' : undefined)};
  background-color: ${({ idRol }) => ((idRol || 0) % 2 !== 0 ? 'rgba(0, 0, 0, 0.05)' : undefined)};
`;

type Actions = 'delete' | 'cv' | 'add';
export type RolComite = { idRolComite: number; nombre: string; descripcion: string };
type Props = RolComite & {
  onRowClick: (action: Actions, row?: MiembroComiteType) => void;
  esCC?: boolean;
};
export const ComiteRow = (props: Props) => {
  const { nombre, idRolComite, onRowClick, esCC } = props;

  const { miembros } = useComite();

  const finalData = useMemo(
    () =>
      miembros
        ?.filter((e) => e.comite_rol === idRolComite)
        .sort((a, b) => Number(b.titular) - Number(a.titular)) ?? [],
    [miembros, idRolComite],
  );

  if (finalData.length === 0) {
    return (
      <Row bottomBorder idRol={idRolComite}>
        <CenterdCol>{nombre}</CenterdCol>
        <CenterdCol colSpan={7}>
          <i>Sin miembros</i>
        </CenterdCol>
        {esCC && (
          <CenterdCol>
            <LinkBtn transparent onClick={() => onRowClick('add')}>
              <i className="fa fa-lg fa-user-plus text-success"></i>
            </LinkBtn>
          </CenterdCol>
        )}
      </Row>
    );
  }

  return (
    <>
      {finalData.map((m, i) => (
        <Row key={m.cuil} bottomBorder={i === finalData.length - 1} idRol={idRolComite}>
          {i === 0 && <CenterdCol rowSpan={finalData.length}>{nombre}</CenterdCol>}
          <CenterdCol bottomBorder={finalData[i + 1]?.titular !== m.titular}>
            {m.titular ? 'Titular' : 'Alterno'}
          </CenterdCol>
          <CenterdCol>{`${m.apellido}, ${m.nombre}`}</CenterdCol>
          <CenterdCol>{m.cuil}</CenterdCol>
          <CenterdCol>{m.email}</CenterdCol>
          <CenterdCol>{m.telefono}</CenterdCol>
          <CenterdCol>
            <LinkBtn transparent size="sm" onClick={() => onRowClick('cv', m)}>
              <i className="fa fa-file-pdf-o" />
            </LinkBtn>
          </CenterdCol>
          {esCC && (
            <CenterdCol>
              <LinkBtn transparent size="sm" onClick={() => onRowClick('delete', m)}>
                <i className="fa fa-lg fa-trash text-danger" />
              </LinkBtn>
            </CenterdCol>
          )}
          {i === 0 && esCC && (
            <CenterdCol rowSpan={finalData.length}>
              <LinkBtn transparent onClick={() => onRowClick('add', m)}>
                <i className="fa fa-lg fa-user-plus text-success" />
              </LinkBtn>
            </CenterdCol>
          )}
        </Row>
      ))}
    </>
  );
};
